import { useState } from "react";
import { useGetStoredFilesForMediaQuery } from "../../../../store/api/kinesense";
import { ReviewVideoListItemTrayContentProps } from "./ReviewVideoListItemFooter";
import { Notifications } from "../../../../utilities/Notifications/Notifications";
import { tryExtractErrorMessage } from "../../../../utilities/helpers";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export type ReviewVideoListItemFilesProps = ReviewVideoListItemTrayContentProps;

export function ReviewVideoListItemFiles(props: ReviewVideoListItemFilesProps) {
    const media = props.data;

    const {
        data: storedFiles,
        isError,
        isLoading,
        isUninitialized,
        refetch: refetchStoredFile,
    } = useGetStoredFilesForMediaQuery(
        { projectId: media?.projectId, mediaId: media?.mediaId },
        { skip: media?.mediaId === undefined },
    );

    async function downloadFile(fileName: string, url: string) {
        try {
            const urlObj = new URL(url);
            const a = document.createElement("a");
            a.href = urlObj.href;
            a.download = `${fileName}`;
            a.target = "_blank";
            a.click();

            URL.revokeObjectURL(urlObj.href);
        } catch (e) {
            Notifications.notify(
                "Failed to download clip",
                `The following error was encountered while attempting to download a clip: ${tryExtractErrorMessage(e)}`,
            );
        }
    }

    return (
        <div className="gap-1 inner d-flex flex-column">
            <section className="overflow-hidden">
                <table>
                    <tbody>
                        {isLoading && (
                            <tr>
                                <td colSpan={2}>Loading...</td>
                            </tr>
                        )}
                        {isError && (
                            <tr>
                                <td colSpan={2}>Error loading files</td>
                            </tr>
                        )}
                        {isUninitialized && (
                            <tr>
                                <td colSpan={2}>No files found</td>
                            </tr>
                        )}
                        {Array.from(storedFiles)
                            ?.filter((file) => file[1].intent == "media")
                            .toSorted((a, b) => a[1].key.split("/").pop().localeCompare(b[1].key.split("/").pop()))
                            .map((file) => (
                                <tr key={file[1].fileId}>
                                    <td
                                        style={{
                                            width: "100%",
                                            maxWidth: "200pt",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {file[1].key.split("/").pop()}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        <button
                                            className="button-with-icon"
                                            style={{ height: "20pt", width: "20pt", display: "inline" }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                downloadFile(file[1].key.split("/").pop(), file[1].accessUrl.url);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faDownload} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </section>
        </div>
    );
}
